import { SlideAction, useSlideLayout } from '@gripp/shared-ui';
import { Icon } from 'libs/shared-ui/src/components/crop-circle/icons/Icon';
import { Pressable, StyleSheet, View } from 'react-native';
import { useLocation, useNavigate } from 'react-router';

export const AssetRoutinesHeader = ({ assetId }: { assetId: string }) => {
  const { onSlideChange } = useSlideLayout();
  const location = useLocation();
  const navigate = useNavigate();

  const onAssetEdit = async () => {
    const basePath = `/assets/${assetId}/routines`;

    if (location.pathname.includes(`${basePath}/all`)) {
      await onSlideChange(SlideAction.NEXT);
    }

    navigate(`${basePath}/edit`);
  };

  return (
    <View style={styles.filtersContainer}>
      <Pressable onPress={onAssetEdit}>
        <Icon name="Settings" size={24} />
      </Pressable>
    </View>
  );
};

const styles = StyleSheet.create({
  filtersContainer: {
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    gap: 16,
  },
});
